export default "__VITE_ASSET__KgBomf59__"